import React, { useState, useEffect } from "react";
import { Row, Col } from "reactstrap";
import {
  GridComponent,
  Inject,
  ColumnDirective,
  ColumnsDirective,
  CommandColumn,
  Page,
  Filter,
  Toolbar,
  ExcelExport,
  Sort,
  Resize,
  Group,
  Freeze,
  row,
} from "@syncfusion/ej2-react-grids";
import { HeaderDivider } from "../../../utilities/utll";
import { useNearToExpiryStore } from "../../../store/useNearToExpiryStore";

const BasicGrid = ({ onEditRow }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const { expiryDiscountList } = useNearToExpiryStore();

  const userCommands = [
    {
      type: "Edit",
      buttonOption: { cssClass: "e-flat", iconCss: "e-edit e-icons" },
    },
  ];
  let gridInstance;
  const handleCommandClick = (args) => {
    if (args.commandColumn.type === "Edit") {
      const rowData = args.rowData;

      const mappedData = {
        Id: rowData.Id,
      };

      onEditRow(mappedData);
    }
  };

  return (
    <>
        <div
          className={`grid_compact ${isMobile ? "e-bigger" : ""}`}
          style={{
            position: "relative",
            marginTop: "10px",
            background: "#fff",
            borderRadius: 12,
            boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
            padding: "6px",
            marginBottom: "20px",
          }}
        >
          <Row>
            <Col>
              <GridComponent
                ref={(g) => (gridInstance = g)}
                id="BrokerGrid"
                dataSource={expiryDiscountList}
                allowPaging={true}
                allowSorting={true}
                allowFiltering={true}
                filterSettings={{ type: "Excel" }}
                toolbar={["Search"]}
                enableAdaptiveUI={isMobile}
                rowRenderingMode={isMobile ? "Vertical" : "Horizontal"}
                gridLines="Both"
                height={"300px"}
                pageSettings={{
                  pageSizes: [10, 20, 30, 40, 50, "All"],
                  pageCount: 10,
                }}
                rowHeight={isMobile ? "" : 32}
                // frozenColumns={1}
                allowResizing={true}
                dataBound={() => {
                  if (!isMobile && gridInstance) {
                    gridInstance.autoFitColumns();
                  }
                }}
                commandClick={handleCommandClick}
                // rowDataBound={()}
                // commandClick={handleCommandClick}
              >
                <ColumnsDirective>
                  <ColumnDirective
                    field="serialNo"
                    headerText="S No"
                    width="90"
                    textAlign="Center"
                    allowFiltering={false}
                  />
                  <ColumnDirective
                    field="Id"
                    headerText="S No"
                    width="90"
                    textAlign="Center"
                    allowFiltering={false}
                    visible={false}
                  />
                  <ColumnDirective
                    field="DivisionCode"
                    headerText="Division"
                    width="150"
                    textAlign="Left"
                  />
                  <ColumnDirective
                    field="divisionName"
                    headerText="Division Name"
                    width="150"
                    textAlign="Left"
                  />
                  <ColumnDirective
                    field="DepartmentCode"
                    headerText="Department"
                    width="200"
                    textAlign="Left"
                  />
                  <ColumnDirective
                    field="departmentName"
                    headerText="Department Name"
                    width="250"
                    textAlign="Left"
                  />
                  <ColumnDirective
                    field="Discount1"
                    headerText="Expiry Discount"
                    width="250"
                    textAlign="Left"
                  />
                  <ColumnDirective
                    field="Discount2"
                    headerText="Near Expiry Discount"
                    width="150"
                    textAlign="Left"
                  />

                  <ColumnDirective
                    headerText="Actions"
                    commands={userCommands}
                    width="120"
                    textAlign="Center"
                  />
                </ColumnsDirective>

                <Inject
                  services={[
                    CommandColumn,
                    Page,
                    Filter,
                    Toolbar,
                    ExcelExport,
                    Sort,
                    Group,
                    Resize,
                    Freeze,
                  ]}
                />
              </GridComponent>
            </Col>
          </Row>
        </div>
    </>
  );
};

export default BasicGrid;
